'use es6';

import getPropertyValues from './getPropertyValues';
export default ((property, dataset) => {
  return getPropertyValues(property, dataset).filterNot(value => Boolean(value.get('label'))).map(value => value.get('raw')).toSet();
});